import "../MedHelpList/MedHelpList.scss";
import React, { useState } from "react";

function MedHelpList({ allResources }) {
  const [search, setSearch] = useState("");
  const [searchType, setSearchType] = useState("location"); // default: province/location

  if (!allResources) {
    return <p>Loading...</p>;
  }

  // Filter logic based on dropdown choice
  const filteredResources = allResources.filter((item) => {
    if (!search) return true; // no search term = show all
    const term = search.toLowerCase();

    if (searchType === "location") {
      return item.location.toLowerCase().includes(term);
    }

    if (searchType === "name") {
      return item.name.toLowerCase().includes(term);
    }

    if (searchType === "title") {
      return item.title.toLowerCase().includes(term);
    }

    return true;
  });

  return (
    <div className="resources">
      <h1 className="resources__title">Grief and Wellness Support</h1>
      <form className="resources__form" onSubmit={(e) => e.preventDefault()}>
        {/* Dropdown to select search type */}

        {/* beginning of test! */}
        <div className="resources__search-wrapper">
          {/* end of test, but also delete the end div if removed. */}

          <select
            className="resources__dropdown"
            value={searchType}
            onChange={(e) => setSearchType(e.target.value)}
          >
            <option value="location">Province</option>
            <option value="name">Name</option>
            <option value="title">Title</option>
          </select>

          {/* Search input */}
          <input
            className="resources__search"
            name="search"
            id="search"
            type="text"
            placeholder={`Search by ${searchType}...`}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </form>

      {/* Render filtered resources */}
      {filteredResources.map((item) => (
        <div key={item.id} className="resources-cards">
          <div className="resources-cards__container">
            <div className="resources-cards__top">
              <h2 className="resources-cards__name">{item.name}</h2>
              <h3 className="resources-cards__title">{item.title}</h3>
              <p className="resources-cards__address">{item.location}</p>
            </div>

            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="resources-cards__description"
            >
              Find Out More
            </a>
          </div>
        </div>
      ))}
    </div>
  );
}

export default MedHelpList;
//------------------------------------------------------------
// import "../MedHelpList/MedHelpList.scss";
// import React, { useState } from "react";

// function MedHelpList({ allResources, setAllResources }) {
//   const [search, setSearch] = useState("");
//   if (!allResources) {
//     return <p>Loading...</p>;
//   }

//   return (
//     <div className="resources">
//       <h1 className="resources__title">Grief and Wellness Support</h1>
//       <form className="resources__form">
//         <input
//           className="resources__search"
//           name="search"
//           id="search"
//           type="text"
//           placeholder="Search by province."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />
//       </form>
//       {allResources
//         .filter((item) => {
//           return search.toLowerCase() === ""
//             ? item
//             : item.location.toLowerCase().includes(search);
//         })
//         .map((item, index) => (
//           <div key={item.id} className="resources-cards">
//             <div className="resources-cards__container">
//               <div className="resources-cards__top">
//                 <h2 className="resources-cards__name">{item.name}</h2>

//                 <h3 className="resources-cards__title">{item.title}</h3>
//                 <p className="resources-cards__address">{item.location}</p>
//               </div>

//               <a
//                 href={item.url}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="resources-cards__description "
//               >
//                 Find Out More
//               </a>
//             </div>
//           </div>
//         ))}
//     </div>
//   );
// }
// export default MedHelpList;
